import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

// *load data silo stock
function* loadDataSiloStock(action) {
  const {
    data: { locations_id, filter, accessToken },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-data-silo-stock`,
      {
        locations_id,
        filter,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.loadDataSiloStock.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadDataSiloStock.failure())
  }
}
// *update data silo stock
function* updateRequireStock(action) {
  const {
    data: { update_data, accessToken },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/update-data-silo-stock`,
      {
        update_data,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    loading(res.data)
    yield put(actions.updateRequireStock.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.updateRequireStock.failure())
  }
}
// *load location list
function* loadLocationLists(action) {
  const {
    data: { location_visibility, accessToken },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-locations-silo-stock`,
      {
        location_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.loadLocationLists.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadLocationLists.failure())
  }
}
// *get data raw mat usage
function* getDataStockDetail(action) {
  const {
    data: { plant_id, material_id, silo_no, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-data-stock-detail`,
      {
        plant_id,
        material_id,
        silo_no,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.getDataStockDetail.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.getDataStockDetail.failure())
  }
}

// *get data stock balance
function* getDataStockBalance(action) {
  const {
    data: { stock_date, plant_id, material_id, silo_no, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-isupply-stock-balance-by-payload`,
      {
        stock_date,
        plant_id,
        material_id,
        silo_no,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.getDataStockBalance.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.getDataStockBalance.failure())
  }
}

// create stock balance
function* createStockBalance(action) {
  const {
    data: {
      id,
      stock_date,
      plant_id,
      material_id,
      silo_no,
      qty,
      actual_qty,
      diff_qty,
      create_by_id,
      update_by_id,
      remark,
      accessToken,
    },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/create-isupply-stock-balance`,
      {
        id,
        stock_date,
        plant_id,
        material_id,
        silo_no,
        qty,
        actual_qty,
        diff_qty,
        create_by_id,
        update_by_id,
        remark,
        matching_name: 'isupply-stock-balance',
        action_name: 'edit',
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    loading(res.data)
    yield put(actions.createStockBalance.success(res.data))
  } catch (err) {
    yield put(actions.createStockBalance.failure())
  }
}
// *update stock balance
function* updateStockBalance(action) {
  const {
    data: { id, qty, actual_qty, diff_qty, update_by_id, remark, accessToken },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/update-isupply-stock-balance`,
      {
        id,
        qty,
        actual_qty,
        diff_qty,
        update_by_id,
        remark,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    loading(res.data)
    yield put(actions.updateStockBalance.success(res.data))
  } catch (err) {
    yield put(actions.updateStockBalance.failure())
  }
}

// *export stock balance
function* materialStockExportStockBalance(action) {
  const {
    data: {
      stock_date,
      plant_id,
      material_id,
      silo_no,
      col_value,
      start_date,
      end_date,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/material-stock/export-stock-balance`,
      {
        stock_date,
        plant_id,
        material_id,
        silo_no,
        col_value,
        start_date,
        end_date,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.materialStockExportStockBalance.success(res.data))

    const sftpPath = res.data.data
    const downloadRes = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
      { sftp_path: sftpPath },
      { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
    )
    const ext = sftpPath.split('.').pop().toLowerCase()
    const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const blob = new Blob([downloadRes.data], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = sftpPath.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (err) {
    yield put(actions.materialStockExportStockBalance.failure())
  }
}

// *get data plant silo setting
function* materialStockGetDataPlantSiloSetting(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-data-plant-silo-setting`,
      {
        id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.materialStockGetDataPlantSiloSetting.success(res.data))
  } catch (err) {
    yield put(actions.materialStockGetDataPlantSiloSetting.failure())
  }
}

// *update data plant silo setting
function* materialStockUpdateDataPlantSiloSetting(action) {
  const {
    data: {
      id,
      multiple_automate_order_material_time,
      auto_order_status,
      min_quantity_per_trip,
      enable_limit_auto_order,
      limit_auto_order,
      safety_morning,
      safety_evening,
      enable_notification_stock_unbalance,
      apply_all,
      create_by_id,
      update_by_id,
      accessToken,
      auto_order_day,
      not_calculate_silo_no_for_create_ticket,
      calculate_with_cement_use,
      auto_order_afternoon_delivery_morning,
      auto_order_priority,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/update-plant-silo-stock-config`,
      {
        id,
        multiple_automate_order_material_time,
        auto_order_status,
        min_quantity_per_trip,
        enable_limit_auto_order,
        limit_auto_order,
        safety_morning,
        safety_evening,
        enable_notification_stock_unbalance,
        apply_all,
        create_by_id,
        update_by_id,
        matching_name: 'isupply-stock-balance',
        action_name: 'edit',
        auto_order_day,
        not_calculate_silo_no_for_create_ticket,
        calculate_with_cement_use,
        auto_order_afternoon_delivery_morning,
        auto_order_priority,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.materialStockUpdateDataPlantSiloSetting.success(res.data))
  } catch (err) {
    yield put(actions.materialStockUpdateDataPlantSiloSetting.failure())
  }
}

export default function* watchMaterialStock() {
  yield all([
    takeEvery(actions.LOAD_DATA_SILO_STOCK.REQUEST, loadDataSiloStock),
    takeEvery(actions.UPDATE_REQUIRE_STOCK.REQUEST, updateRequireStock),
    takeEvery(actions.LOAD_LOCATION_LISTS.REQUEST, loadLocationLists),
    takeEvery(actions.GET_DATA_STOCK_DETAIL.REQUEST, getDataStockDetail),
    takeEvery(actions.GET_DATA_STOCK_BALANCE.REQUEST, getDataStockBalance),
    takeEvery(actions.CREATE_STOCK_BALANCE.REQUEST, createStockBalance),
    takeEvery(actions.UPDATE_STOCK_BALANCE.REQUEST, updateStockBalance),
    takeEvery(
      actions.MATERIAL_STOCK_EXPORT_STOCK_BALANCE.REQUEST,
      materialStockExportStockBalance
    ),
    takeEvery(
      actions.MATERIAL_STOCK_GET_DATA_PLANT_SILO_SETTING.REQUEST,
      materialStockGetDataPlantSiloSetting
    ),
    takeEvery(
      actions.MATERIAL_STOCK_UPDATE_DATA_PLANT_SILO_SETTING.REQUEST,
      materialStockUpdateDataPlantSiloSetting
    ),
  ])
}
export {
  loadDataSiloStock,
  updateRequireStock,
  loadLocationLists,
  getDataStockDetail,
  getDataStockBalance,
  createStockBalance,
  updateStockBalance,
  materialStockExportStockBalance,
  materialStockGetDataPlantSiloSetting,
  materialStockUpdateDataPlantSiloSetting,
}
